function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFCB6F",
  d: "M16.342 12.105H0V9.08h16.342z"
}), React.createElement("path", {
  fill: "#434343",
  d: "M23 3.026H0V0h23z"
}), React.createElement("path", {
  fill: "#FEDEA7",
  d: "M11.5 21.79H0v-3.027h11.5z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 23,
  height: 22,
  viewBox: "0 0 23 22"
}, props), _ref);

export default __webpack_public_path__ + "static/media/icon-subscription-business.63003633.svg";
export { SvgComponent as ReactComponent };